import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)"}`,
    borderRadius: 8,
    cursor: "pointer",
    height: "100%",
    minHeight: 100,
    transition: "all 0.15s ease-in-out",
    "&:hover": {
      borderColor: "#25d366",
      backgroundColor: theme.palette.type === "dark" ? "rgba(37,211,102,0.08)" : "rgba(37,211,102,0.06)",
      transform: "translateY(-2px)",
    },
  },
  dot: {
    width: 32,
    height: 32,
    borderRadius: "50%",
  },
  name: {
    fontSize: 13,
    fontWeight: 600,
    marginTop: theme.spacing(1),
    maxWidth: "100%",
    textAlign: "center",
  },
}));

/**
 * Popup em grade para escolher a fila de um chamado novo aberto pelo atendente
 * (quem tem mais de uma fila precisa dizer em qual o atendimento nasce).
 *
 * Props:
 * - open, onClose: fechar sem escolher cancela a abertura do chamado
 * - queues: filas do usuário ({ id, name, color })
 * - onSelect(queueId)
 * - title: título do diálogo
 */
const QueueSelectDialog = ({
  open,
  onClose,
  queues,
  onSelect,
  title = i18n.t("queueSelectDialog.title"),
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={() => onClose && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} style={{ marginBottom: 4 }}>
          {(queues || []).map((queue) => (
            <Grid item xs={6} sm={4} key={queue.id}>
              <Box className={classes.card} onClick={() => onSelect && onSelect(queue.id)}>
                <span
                  className={classes.dot}
                  style={{ backgroundColor: queue.color || "#7c7c7c" }}
                />
                <Typography noWrap className={classes.name}>
                  {queue.name}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose && onClose()} color="secondary">
          {i18n.t("common.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueueSelectDialog;
